import { DATE_FORMAT, PARAMETER_DATE_FORMAT_WITHOUT_TZ } from "@gymflow/common";
import { formatCurrency } from "@gymflow/helpers";
import { useClubSettings } from "apps/portal/src/providers";
import moment from "moment";
import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../../routes/feature";
import { RouteLayout } from "../../../../../routes/layout";
import ReportWidgetCard from "../../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../../ReportContext";
import { TransactionType } from "../../../Revenue";

export const ReportRevenueTransactionDetailsAwaitingAuthWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);
  const history = useHistory();
  const { club } = useClubSettings();

  return (
    <ReportWidgetCard
      title="Awaiting Authorization"
      value={formatCurrency(
        Math.round(data.revenue?.awaitingAuth?.total || 0),
        club.defaultCurrency,
        true,
      )}
      isLoading={data.isLoading}
      variation={data.revenue?.awaitingAuth?.variation}
      explanation="Sum of all amounts that require further authorization to finish processing. Any amounts not authorized will not be collected."
      onClick={() =>
        history.push({
          pathname: createClubLink(
            RouteLayout.Staff,
            RouteFeature.RevenueTransaction,
          ),
          search: QueryString.stringify({
            dates: {
              startDate: moment(data.startDate, DATE_FORMAT).format(
                PARAMETER_DATE_FORMAT_WITHOUT_TZ,
              ),
              endDate: moment(data.endDate, DATE_FORMAT)
                .endOf("day")
                .format(PARAMETER_DATE_FORMAT_WITHOUT_TZ),
            },
            type: TransactionType.PENDING_AUTHORIZATION,
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
